<template>
    <div class="site">
        <Title firstName="变配电概况" lastName="DISTRIBUTION OVERVIEW"/>
        <div class="content">
            <div class="box">
                <div class="boxitem">
                    <p>日均负荷率</p>
                    <p>42.5 <span>%</span> </p>
                </div>
                <div class="boxitem">
                    <p>配电站数量</p>
                    <p>2</p>
                </div>
                <div class="boxitem">
                    <p>输出容量</p>
                    <p>800 <span>kVA</span> </p>
                </div>
            </div>
            <div class="interaction">
                <div class="interactionitem">
                    电流走向图
                </div>
                <div class="interactionitem">
                    电气结构图
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')

export default {
    data(){
        return {

        }
    },
    components:{
        Title
    }
}
</script>
 
<style lang="less" scoped>
    .site{
        width: 20vw;
        height: 22.2vh;
        position: fixed;
        top: 7.4vh;
        left: 2vw;
        z-index: 1;
        .content{
            background: linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            height: 17.5vh;
            .box{
                width: 100%;
                height: 50%;
                display: flex;
                justify-content: space-evenly;
                align-items: center;

                .boxitem{
                    text-align: center;
                    p:nth-child(1){
                        color: rgba(230,243,253, 0.7);
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                    }
                    p:nth-child(2){
                        margin-top: 8rem;
                        color: #00DEFF;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        &>span{
                        font-size: 14rem;
                        }
                    }
                }
            }
            .interaction{
                width: 100%;
                height:50%;
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                .interactionitem{
                    width: 102rem;
                    height: 32rem;
                    line-height: 32rem;
                    text-align: center;
                    background: url('../../../../assets/img/interaction.png');
                    background-size: 100% 100%;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    font-size: 14rem;
                    color: rgba(255, 255, 255, 0.7);
                }
            }
        }
    }
</style>